import * as yup from 'yup';

import { ObjectTypeBase } from '../../../baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../../../properties/Property';
import { AllTypeContexts } from '../../../properties/TypeContextEnum';

import { Types } from '../../../properties/Types';
import { DateTimeDefinition } from '../../../properties/baseTypes/DateTime';
import { EmailDefinition } from '../../../properties/baseTypes/Email';
import { ImageDefinition } from '../../../properties/baseTypes/Image';
import { PhoneNumberDefinition } from '../../../properties/baseTypes/PhoneNumber';
import { uuidTypeDefinition } from '../../../properties/baseTypes/UUID';
import { TYPE_GROUP_INTEGRATION } from '../../../properties/constants';
import { createShapeFromProperties } from '../../../properties/createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'String',
  },
  firstName: {
    type: 'String',
  },
  lastName: {
    type: 'String',
  },
  companyName: {
    type: 'String',
  },
  email: {
    type: 'Email',
  },
  phone: {
    type: 'PhoneNumber',
  },
  mobile: {
    type: 'PhoneNumber',
  },
  picture: {
    type: 'String',
  },
  createdAt: {
    type: 'DateTime',
  },
};

export class ProxyClickHostType extends ObjectTypeBase {
  group = TYPE_GROUP_INTEGRATION;

  name = 'ProxyClickHost';

  friendlyName = 'Proxyclick Host';

  superUserOnly = true;

  contexts = AllTypeContexts;

  get example() {
    return {
      _id: uuidTypeDefinition.example,
      firstName: 'Lane',
      lastName: 'Doe',
      companyName: 'Lane Technologies Inc.',
      email: EmailDefinition.example,
      phone: PhoneNumberDefinition.example,
      mobile: PhoneNumberDefinition.example,
      picture: ImageDefinition.example,
      createdAt: DateTimeDefinition.example,
    };
  }

  get default(): any {
    return {
      _id: '',
      firstName: '',
      lastName: '',
      companyName: '',
      email: '',
      phone: null,
      mobile: null,
      picture: null,
      createdAt: null,
    };
  }

  buildSchema() {
    return yup.object().shape(createShapeFromProperties(properties)).nullable();
  }

  properties = properties;
}

const definition = new ProxyClickHostType();

Types.addType(definition);
export { definition };
